import { useEffect, useState } from 'react';

const QUERY = '(max-width: 767px)';

/** Phone-sized screen (below Tailwind's `md`). Read synchronously on mount, so intro animations pick the right variant. */
export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(() => typeof window !== 'undefined' && window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const sync = () => setMobile(mq.matches);
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);
  return mobile;
}
